<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Relación de personas a asegurar</h6>
            </template>
            <p class="text-muted small mb-2">
              Si el empleado se va a asegurar debe relacionarse. Complete los datos de cada persona.
            </p>
            <div class="table-responsive">
              <table class="table-one tabla-personas-salud">
                <thead>
                  <tr>
                    <th>Nombre(s)</th>
                    <th>Apellido(s)</th>
                    <th>Nº Identificación</th>
                    <th>Fecha Nac.</th>
                    <th>Parentesco</th>
                    <th>Peso (kg)</th>
                    <th>Estatura (m)</th>
                    <th>Sexo</th>
                    <th>EPS</th>
                    <th style="width: 70px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in form.beneficiarios" :key="index">
                    <td style="display: none">
                      <span>Persona {{ index + 1 }}</span>
                    </td>
                    <td style="width: 14%">
                      <b-form-input type="text" v-model="item.name" :state="getValidationName(index)"></b-form-input>
                    </td>
                    <td style="width: 14%">
                      <b-form-input type="text" v-model="item.lastName"
                        :state="getValidationLastName(index)"></b-form-input>
                    </td>
                    <td style="width: 14%">
                      <b-form-input
                        v-model="item.document"
                        type="text"
                        :state="getValidationDocument(index)"
                      />
                    </td>
                    <td style="width: 10%">
                      <DateGrid
                        :form="item"
                        type="date"
                        name="birthDay"
                        :state="getValidationBirthDay(index)"
                      ></DateGrid>
                    </td>
                    <td style="width: 12%">
                      <b-form-select
                        v-model="item.relation"
                        :options="control.parentescoOptions"
                        :state="getValidationRelation(index)"
                      />
                    </td>
                    <td style="width: 8%">
                      <b-form-input
                        v-model="item.weight"
                        type="number"
                        step="0.1"
                        :state="getValidationWeight(index)"
                      />
                    </td>
                    <td style="width: 8%">
                      <b-form-input
                        v-model="item.stature"
                        type="number"
                        step="0.01"
                        :state="getValidationStature(index)"
                      />
                    </td>
                    <td style="width: 10%">
                      <b-form-select
                        v-model="item.sex"
                        :options="control.sexoOptions"
                        :state="getValidationSex(index)"
                      />
                    </td>
                    <td style="width: 8%">
                      <b-form-input
                        v-model="item.eps"
                        type="text"
                        :state="getValidationEps(index)"
                      />
                    </td>
                    <td>
                      <b-btn pill variant="outline-danger" size="sm" @click="borrarDatosItem(item)"
                        >Borrar</b-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button @click="previous" variant="secondary">Anterior</b-button>
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import { PARENTESCO_SALUD, TIPOS_SEXO } from "@/data/colombia/salud/Selects";
import DateGrid from "@/components/controls/DateGrid.vue";

const CANTIDAD_FILAS_DEFAULT = 6;

function personaVacia() {
  return {
    name: "",
    lastName: "",
    document: "",
    birthDay: "",
    relation: "",
    weight: "",
    stature: "",
    sex: "",
    eps: "",
  };
}

export default {
  name: "FormColombiaSalud02",
  components: { DateGrid },
  data() {
    return {
      control: {
        parentescoOptions: [{ value: null, text: "Seleccione" }, ...PARENTESCO_SALUD],
        sexoOptions: [{ value: null, text: "Seleccione" }, ...TIPOS_SEXO],
      },
      form: {},
    };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/salud/");
      return;
    }
    this.form = form;
    if (!this.form.beneficiarios || !Array.isArray(this.form.beneficiarios)) {
      this.form.beneficiarios = [];
    }
    while (this.form.beneficiarios.length < CANTIDAD_FILAS_DEFAULT) {
      this.form.beneficiarios.push(personaVacia());
    }
    if (this.form.beneficiarios.length > CANTIDAD_FILAS_DEFAULT) {
      this.form.beneficiarios = this.form.beneficiarios.slice(0, CANTIDAD_FILAS_DEFAULT);
    }
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    borrarDatosItem(item) {
      item.name = "";
      item.lastName = "";
      item.document = "";
      item.birthDay = "";
      item.relation = "";
      item.weight = "";
      item.stature = "";
      item.sex = "";
      item.eps = "";
    },
    previous() {
      this.$store
        .dispatch("wizard/save", { index: 1, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-1.html"));
    },
    rowEmpty(index) {
      const p = this.form.beneficiarios[index];
      return (
        !p.name &&
        !p.lastName &&
        !p.document &&
        !p.birthDay &&
        !p.relation &&
        !p.weight &&
        !p.stature &&
        !p.sex &&
        !p.eps
      );
    },
    tableEmpty() {
      return this.form.beneficiarios.every((_, i) => this.rowEmpty(i));
    },
    getValidationName(index) {
      if (this.rowEmpty(index)) return null;
      return this.form.beneficiarios[index].name ? true : false;
    },
    getValidationDocument(index) {
      if (this.rowEmpty(index)) return null;
      return this.form.beneficiarios[index].document ? true : false;
    },
    getValidationBirthDay(index) {
      if (this.rowEmpty(index)) return null;
      return this.form.beneficiarios[index].birthDay ? true : false;
    },
    getValidationRelation(index) {
      if (this.rowEmpty(index)) return null;
      return this.form.beneficiarios[index].relation ? true : false;
    },
    getValidationWeight(index) {
      if (this.rowEmpty(index)) return null;
      return true;
    },
    getValidationStature(index) {
      if (this.rowEmpty(index)) return null;
      return true;
    },
    getValidationSex(index) {
      if (this.rowEmpty(index)) return null;
      return this.form.beneficiarios[index].sex ? true : false;
    },
    getValidationEps(index) {
      if (this.rowEmpty(index)) return null;
      return true;
    },
    getValidationLastName(index) {
      const state = this.rowEmpty(index) || this.form.beneficiarios[index].lastName != "";

      if (state && this.form.beneficiarios[index].lastName == "") {
        return null;
      } else {
        return state;
      }
    },
    validation() {
      let ok = true;
      for (let i = 0; i < this.form.beneficiarios.length; i++) {
        if (!this.rowEmpty(i)) {
          ok =
            ok &&
            this.getValidationName(i) &&
            this.getValidationDocument(i) &&
            this.getValidationBirthDay(i) &&
            this.getValidationRelation(i) &&
            this.getValidationSex(i);
        }
      }
      return ok;
    },
    next() {
      if (this.tableEmpty()) {
        this.$bvToast.toast("Debe cargar al menos una persona a asegurar.", {
          title: "Información incompleta",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (!this.validation()) {
        this.$bvToast.toast("Complete todos los datos de cada persona con datos cargados.", {
          title: "Información incompleta",
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.$store
        .dispatch("wizard/save", { index: 2, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-3.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 100%;
}
.tabla-personas-salud td {
  padding: 0.25rem;
  vertical-align: middle;
}
@media only screen and (max-width: 1000px) {
  .tabla-personas-salud,
  .tabla-personas-salud thead,
  .tabla-personas-salud tbody,
  .tabla-personas-salud th,
  .tabla-personas-salud td,
  .tabla-personas-salud tr {
    display: block;
    position: relative;
  }
  .tabla-personas-salud thead tr {
    display: none;
  }
  .tabla-personas-salud tbody tr {
    margin-bottom: 2rem;
    border: 1px solid #dee2e6;
    padding: 1rem;
  }
  .tabla-personas-salud td {
    border-bottom: 1px solid #eee;
    width: 100% !important;
    padding-top: 1.5rem;
  }
  .tabla-personas-salud td:first-of-type {
    display: block !important;
    border-bottom: 2px solid var(--primary);
    margin-bottom: 0.5rem;
    padding-top: 0.5rem;
  }
  .tabla-personas-salud td::before {
    position: absolute;
    top: 4px;
    left: 6px;
    font-weight: bold;
    font-size: 0.85rem;
  }
  .tabla-personas-salud td:nth-of-type(2):before {
    content: "Nombres";
  }
  .tabla-personas-salud td:nth-of-type(3):before {
    content: "Nº Identificación";
  }
  .tabla-personas-salud td:nth-of-type(4):before {
    content: "Fecha Nac.";
  }
  .tabla-personas-salud td:nth-of-type(5):before {
    content: "Parentesco";
  }
  .tabla-personas-salud td:nth-of-type(6):before {
    content: "Peso (kg)";
  }
  .tabla-personas-salud td:nth-of-type(7):before {
    content: "Estatura (m)";
  }
  .tabla-personas-salud td:nth-of-type(8):before {
    content: "Sexo";
  }
  .tabla-personas-salud td:nth-of-type(9):before {
    content: "EPS";
  }
  .tabla-personas-salud td:nth-of-type(10):before {
    content: "";
  }
}
</style>
